import React from "react";

import NavBar from "../components/NavBar";
import Main from "../components/Main";
import ImageSlider from "../components/Slider";

function HomePage() {
  return (
    <>
      <NavBar />
      <ImageSlider />
      <Main />
    </>
  );
}

export default HomePage;
